module.exports = __webpack_public_path__ + "assets/img/icon-dy-58473203.png";